import React from 'react';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { messages } from '../../../_shared/i18n/messages';

import DateTimeRangePicker from '../DateTimeRangePicker';

const propTypes = {

	/**
	 * The input name.
	 */
	name: PropTypes.string.isRequired,

	/**
	 * The input value.
	 *
	 * For a range of datetimes, it should be an array of two
	 * MomentJS objects or formatted strings.
	 */
	value: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.string),
		PropTypes.arrayOf(PropTypes.instanceOf(moment)),
	]),

	/**
	 * The default timezone to use. Optional — falls back to the viewer's own
	 * zone, since an embedded form renders wherever the learner is.
	 */
	defaultTimezone: PropTypes.string,

	/**
	 * True, if editing the input value.
	 */
	isEditing: PropTypes.bool,

	/**
	 * True, if the input value is invalid.
	 */
	isInvalid: PropTypes.bool,

	/**
	 * True, if the input value is required.
	 */
	isRequired: PropTypes.bool,

	/**
	 * Callback function to handle changes to the input value.
	 */
	onChange: PropTypes.func,

};

const DateTimeInput = (props) => {

	const {
		name,
		value,
		defaultTimezone = moment.tz.guess(),
		isEditing,
		isInvalid,
		isRequired,
		onChange,
	} = props;

	if (!isEditing) {

		if (!value || (Array.isArray(value) && value.length !== 2)) {
			return (
				<span className="tc-material-input-display-empty-value">
					<FormattedMessage {...messages.TC_COMPONENTS_FORM_INPUT_TEXT_EMPTY_VALUE} />
				</span>
			);
		}

		return (
			<div>
				{moment(value[0]).tz(defaultTimezone).format('YYYY-MM-DD h:mma')}
				{' '}
				<FormattedMessage {...messages.TC_COMPONENTS_GENERAL_TEXT_RANGE_GOES_TO} />
				{' '}
				{moment(value[1]).tz(defaultTimezone).format('YYYY-MM-DD h:mma')}
			</div>
		);

	}

	return (
		<div
			className={`
				tc-material-input-datetime-range
				${isInvalid ? 'tc-material-input-invalid' : ''}
			`}>
			<DateTimeRangePicker
				name={name}
				value={value}
				defaultTimezone={defaultTimezone}
				isInvalid={isInvalid}
				isRequired={isRequired}
				onChange={onChange} />
		</div>
	);

};

DateTimeInput.propTypes = propTypes;

export default DateTimeInput;
